import React, { useEffect, useState, useContext } from "react"
import PixiBoard from "./board/pixiBoard/PixiBoard"

import {
  AppContainer,
  GlobalStyle,
  Settings,
  GameRules,
  History,
  useBlurAndAbove,
  Error,
  Notification,
  Loading,
} from "@orbital/games-frontend-library"
import Game from "./Game"
import { colors } from "../lib/colors"
import RedBorder from "./board/redBorder/RedBorder"
import Beep from "../lib/assets/audio/beep.mp3"
import Impact from "../lib/assets/audio/impact.mp3"
import useSound from "use-sound"
// import { saveAudioAndSend, setAudios } from "../settings/useSettings"
import DefaultRules from "../pages/gameRules/DefaultRules"
import { handleBackgroundSFX } from "../helpers/playBackground"
import { useCustomLoader } from "../pages/loader/Loader"

import { MyContext } from "../context/createContext"
import { gameAbortHandler } from "./helpers"

let timerAlarm: any
let timerImpact: any
// import { defaultContext } from "../context/defaultContext"
export default function Astro({
  round,
  users,
  cashoutedUser,
  isError,
  errorText,
  notification,
  handleNotification,
  notificationfadeOut,
  placedBet,
  handleBetOnExplosion,
  settings,
  astroSocketMessages,
  setbetSend,
  betError,
}: any) {
  const { ctx } = useContext(MyContext)
  const { auth, audio, funcs, history, stake } = ctx
  const { setAudio } = funcs
  const [blur, unBlur, settingsUnblur, above, handleAbove] = useBlurAndAbove()

  const handleAudio = (a: any) => {
    astroSocketMessages.settingsPost({ ...settings, audio: a, stake })
    setAudio(a)
  }

  useEffect(() => {
    setAudio && setAudio(settings.audio)
  }, [settings.audio, setAudio])

  const [showLoader, duration] = useCustomLoader(handleAbove, auth.player_id)

  // TODO needs refactor
  handleBackgroundSFX(audio, errorText, showLoader)

  const [isLose, setisLose] = useState<boolean>(false)

  const [alarmSFX, { stop: stopAlarm }] = useSound(Beep, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
    soundEnabled: audio.sound,
  })
  const [impactSFX, { stop: stopImpact }] = useSound(Impact, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
    soundEnabled: audio.sound,
  })
  useEffect(() => {
    // is lose variable
    if (round.state === 1) {
      setisLose(false)
    }
    if (round.state === 3) {
      if (errorText === false) {
        document.visibilityState === "visible" && alarmSFX()
        timerAlarm = setInterval(() => {
          document.visibilityState === "visible" && alarmSFX()
        }, 500)
        setTimeout(() => {
          clearInterval(timerAlarm)
        }, 2500)
        timerImpact = setTimeout(() => {
          document.visibilityState === "visible" && impactSFX()
        }, 2400)
      } else {
        clearInterval(timerAlarm)
        clearTimeout(timerImpact)
        stopImpact()
        stopAlarm()
      }
      setisLose(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [round.state, errorText])

  const handleAbortGame = () => gameAbortHandler(ctx, round.state)
  return (
    <AppContainer color={colors.primary}>
      <GlobalStyle />
      <Game
        blur={blur}
        round={round}
        users={users}
        colors={colors}
        audio={audio}
        notification={notification}
        handleNotification={handleNotification}
        isError={isError}
        placedBet={placedBet}
        handleAbove={handleAbove}
        handleBetOnExplosion={handleBetOnExplosion}
        setbetSend={setbetSend}
        betError={betError}
      />
      <PixiBoard
        round={round}
        cashoutedUser={cashoutedUser}
        handleAbortGame={handleAbortGame}
      />
      <RedBorder isLose={isLose} />
      {above === "settings" && (
        <Settings
          clickable={true}
          unBlur={settingsUnblur}
          colors={{
            ...colors,
            primary: "#301E56",
            primaryLight: colors.primaryDark,
          }}
          handleAbove={handleAbove}
          handleAudio={handleAudio}
          audio={audio}
          customPages={["Game Rules", "History"]}
        />
      )}
      {above === "Game Rules" && (
        <GameRules
          colors={{
            ...colors,
            primary: colors.secondary,
            secondaryBackground: colors.primaryDark,
          }}
          handleAbove={handleAbove}
          audio={audio}
        >
          <DefaultRules />
        </GameRules>
      )}
      {above === "History" && (
        <History
          className="history"
          clickable={true}
          unBlur={unBlur}
          handleAbove={handleAbove}
          history={history}
          audio={audio}
          toFix={2}
          user_id={auth.player_id}
          colors={{
            ...colors,
            primary: colors.secondary,
            secondaryBackground: colors.primaryDark,
          }}
          handleNotification={handleNotification}
          payout={true}
          // multiplier={true}
        />
      )}
      {showLoader && <Loading duration={duration} />}
      {notification && (
        <Notification
          colors={{ ...colors, tertiary: colors.primary }}
          fadeOut={notificationfadeOut}
          handleNotification={handleNotification}
          text={notification}
          unBlur={unBlur}
          audio={audio}
        />
      )}
      {!!errorText && <Error text={errorText} unBlur={false} audio={audio} />}
    </AppContainer>
  )
}
